import c from './Landing.module.css';
import { MARQUEE } from './data';

export function Marquee() {
  // Duplicated so the -50% translate loops seamlessly.
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <section className={c.marquee} aria-hidden="true">
      <div className={c.marqueeTrack}>
        {items.map((m, i) => (
          <span key={`${m}-${i}`} className={c.marqueeItem}>{m}<span>✦</span></span>
        ))}
      </div>
    </section>
  );
}
